import React, { useState } from 'react';
import { Container, TextField, Button, Grid, Typography } from '@mui/material';
 
import apiInstance from '../../../../services/ServiceApi';
import EmpresaUser from './EmpresaUser';
import PermissionsComponent from './PermisosList';
import EmpresaDetailList from '../../../../components/empresa/EmpresaDetailList';

const UploadUserForm = () => {
  const [file, setFile] = useState(null);
  const [permisos, setPermisos] = useState([]);
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState([]);
  const [grupos, setGrupos] = useState(0);
  const [lineaSeleccionada, setLineaSeleccionada] = useState([]);
  const [dashboardSeleccionado, setDashboardSeleccionado] = useState([]);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleSelectedData = (selectedPerms, selectedGrps) => {
    setPermisos(selectedPerms)
    setGrupos(selectedGrps)
    // Aquí puedes guardar estos datos en el estado o manejarlos como necesites.
};

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (!file) {
      alert('Por favor, selecciona un archivo.');
      return;
    }

    const formData = new FormData();
    formData.append('usuario', file);
    formData.append('permisos', permisos.map(per => per.id));
    formData.append('linea', lineaSeleccionada.map(linea => linea.id));
    try {
      const response = await apiInstance.post('loadUser/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      alert('Usuarios cargados correctamente');
      // Manejar la respuesta aquí
    } catch (error) {
      // Manejar el error aquí
      console.error('Hubo un error al cargar los usuarios:', error);
      alert('Error al cargar usuarios');
    }
  };

  return (
    <Container maxWidth="md">
      <Typography variant="h4" component="h1" gutterBottom>
        Cargar Usuarios
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              type="file"
              onChange={handleFileChange}
              fullWidth
              variant="outlined"
              margin="normal"
            />
          </Grid>
          <Grid item xs={12}>

          <EmpresaDetailList
                        lineasSeleccionadas={lineaSeleccionada}
                        dashboardsPreseleccionados = {dashboardSeleccionado}
                        onLineaNegocioSelection={setLineaSeleccionada}
                        onDashboardSelection={setDashboardSeleccionado}
                    />
 
          </Grid>
          <Grid item xs={12}>

            <PermissionsComponent 
                      onSelectionPermissionsChange={setPermisos}
                      onSelectionGroupsChange ={setGrupos}
                      preselectedPermissions ={permisos}
                      preselectedGroups = {grupos}
                    
                    />
             
            </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
            >
              Subir Usuarios
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};

export default UploadUserForm;
